import React, { useContext, useState, useEffect } from "react";
import { debug, deepCopy } from "../utils";
import { connect } from "react-redux";
import { Switcher } from "../view/Switcher";
import { TableContext } from "../index";
import { Checkbox } from "../view/Checkbox";
import { useHistory } from "react-router-dom";
import * as deviceService from "./deviceService";
import { DeviceStatus } from "../vars";
import MenuItem from "@mui/material/MenuItem";
import Menu from "@mui/material/Menu";
import { AlertTriangle, Settings, BarChart3, MoreVertical, ShieldCheck } from 'lucide-react';
import { showSuccessToast } from "../validation/ToastContainer";
import { getBaselineConfirmPopup, POPUP_TYPES } from "../view/popup/PopupContainer";
import { PopupContext } from "../index";

function DevicesTableRow({ data, index, devices, userCapability }) {

    const history = useHistory();
    const { config, setConfig } = useContext(TableContext);
    const [anchorEl, setAnchorEl] = React.useState(null);
    const { setPopup } = useContext(PopupContext);

    // const lineElement = document.getElementById('dynamicwidth');
    // lineElement.style.width = data.pciCompliance+"%";

    //#region Set User Capabilities
    const [deviceDetailsCapability, setDeviceDetailsCapability] = useState(-1);
    const [applyBaselineCapability, setApplyBaselineCapability] = useState(-1);
    const [baselineReportCapability, setBaselineReportCapability] = useState(-1);
    const [authorizationsCapability, setAuthorizationsCapability] = useState(-1);
    useEffect(() => {
        if (userCapability) {
            const deviceDetailsPermission = userCapability.find(item =>
                item.component === "devicedetails" && item.type === "field")?.permission;
            setDeviceDetailsCapability(deviceDetailsPermission);

            const applyBaselinePermission = userCapability.find(item =>
                item.component === "applybaseline" && item.type === "field")?.permission;
            setApplyBaselineCapability(applyBaselinePermission);

            const baselineReportPermission = userCapability.find(item =>
                item.component === "baselinereport" && item.type === "field")?.permission;
            setBaselineReportCapability(baselineReportPermission);

            const authorizationsPermission = userCapability.find(item =>
                item.component === "deviceauthorization" && (item.type === "page" || item.type === "field"))?.permission;
            setAuthorizationsCapability(authorizationsPermission);
        }
        /* eslint-disable react-hooks/exhaustive-deps */
    }, []);
    //#endregion


    useEffect(() => {
        const lineElements = document.querySelectorAll('.dynamicwidth');
        lineElements.forEach((lineElement) => {
            const percentage = parseInt(lineElement.getAttribute('aria-valuenow'));
            lineElement.style.width = `${percentage}%`;
        });
    }, []);

    const getCircleType = () => {
        switch (data.status) {
            case DeviceStatus.CONNECTED:
                return "success";
            case DeviceStatus.DISCONNECTED:
                return "danger";
            case DeviceStatus.UNKNOWN:
                return "info";
            default:
                break;
        }
    }

    // const getProgressBarColor_orig = () => {
    //     if (data.pciCompliance < 40) {
    //         return "danger";
    //     }
    //     if (data.pciCompliance < 80) {
    //         return "warning-darker";
    //     }
    //     if (data.pciCompliance < 100) {
    //         return "info";
    //     }
    //     return "success";
    // }

    //Added By Octopus DevTeam December 8,2022
    const getProgressBarColor = () => {
        if (data.pciCompliance > 0 && data.pciCompliance <= 50) {
            return "danger";
        }
        if (data.pciCompliance > 50 && data.pciCompliance <= 75) {
            return "warning";
        }
        if (data.pciCompliance > 75 && data.pciCompliance <= 90) {
            return "secondary";
        }
        if (data.pciCompliance > 90 && data.pciCompliance <= 100) {
            return "success";
        }

    }

    const onCheckboxChange = () => {
        let selectedRows = deepCopy(config.selected);
        if (selectedRows.includes(data.id)) {
            selectedRows.splice(selectedRows.indexOf(data.id), 1);
        } else {
            selectedRows.push(data.id)
        }
        setConfig({ ...config, selected: selectedRows })
    }

    const onSwitcherChange = (value) => {
        const device = deepCopy(data);
        device.disabled = value;
        deviceService.patch(device)
            .then(() => setConfig({ ...config, lastUpdated: Date.now() }));
    }

    const handleClick = (event) => {
        setAnchorEl(event.currentTarget);
    };

    const handleClose = () => {
        setAnchorEl(null);
    };

    const onApplyBaseline = () => {
        const deviceName = data.hostName;
        const msbName = data.msb.name;
        const deviceType = data.deviceType.name;
        // const appUrl = window.location.href;
        const appUrlProtocol = window.location.protocol;
        const appUrlHostname = window.location.hostname;
        let appUrl = `${appUrlProtocol}//${appUrlHostname}`;
        if (appUrlProtocol === 'http:') {
            appUrl = `${appUrlProtocol}//${appUrlHostname}:4000`;
        }
        let validationUrl = `/validate?f_device=${deviceName}&f_deviceType=${deviceType}&f_msb=${msbName}`;
        if (process.env.NODE_ENV === 'development') {
            validationUrl = appUrl + `/octopus` + validationUrl;
        } else {
            validationUrl = appUrl + validationUrl;
        }

        const deviceDetails = {
            deviceId: data.id,
            deviceTypeId: data.deviceType.pk,
            msbId: data.msb.pk
        }

        setPopup(getBaselineConfirmPopup(deviceName, msbName, async () => {
            const baseline = await deviceService.applyBaseline(deviceDetails);
            if (baseline) {
                setPopup(
                    {
                        type: POPUP_TYPES.BASELINE_DIALOG_RESULT,
                        resultDialog: baseline,
                        url: validationUrl,
                        confirm: () => showSuccessToast("Device Baseline is now Applied!", "Apply Baseline")
                        // .then(() => history.go(0))
                    }
                )

            }

        }))
    }

    const status = data.status.charAt(0).toUpperCase() + data.status.slice(1).toLowerCase();

    return (
        <tr key={index}>
            <td>
                <Checkbox checked={config.selected.includes(data.id)} onClick={() => onCheckboxChange()} />
            </td>
            <td className="oct_cell-host">{data.hostName}</td>
            <td className="oct_cell-ip">{data.mngtIpAddress}</td>
            <td className="oct_cell-status">
                <div className="oct_status-indicator">
                    <div className={`oct_status-dot status-${getCircleType()}`} />
                    <span className={`oct_status-text status-${getCircleType()}`}>{status}</span>
                </div>
            </td>
            <td className="oct_cell-compliant">
                <div className="oct_compliant-wrapper">
                    <span className="oct_compliant-value">{data.pciCompliance}%</span>
                    <div className="oct_compliant-bar-container">
                        <div className="oct_compliant-bar-bg">
                            <div
                                className={`oct_compliant-bar-fill compliant-${getProgressBarColor()} oct_w-${Math.round(data.pciCompliance)}`}
                            />
                        </div>
                    </div>
                </div>
            </td>

            <td>
                <div className="w-35">
                    {/* <div className="custom-control custom-switch"> */}
                    <Switcher value={data.disabled} onClick={onSwitcherChange} />
                    {/* </div> */}
                </div>
            </td>

            <td>
                {/* <a className="btn oct_btn-tool-table" onClick={() => history.push(`/device-details/${data.id}`)}>
                    <i className="fas fa-ellipsis-v"/>
                </a> */}

                {/* <a className="btn oct_btn-tool-table" onClick={() => history.push(`/add-rules/${data.rulePk}`)} >
                    <i className="fas fa-ellipsis-v"></i>
                </a> */}

                <button className="oct_dropdown-trigger-v2" onClick={handleClick} >
                    <MoreVertical className="oct_icon" />
                </button>



                <Menu
                    className="oct_menu-v2"
                    id="dots-options"
                    anchorEl={anchorEl}
                    keepMounted
                    open={Boolean(anchorEl)}
                    onClose={handleClose}>

                    <MenuItem
                        className="oct_menu-item-v2"
                        onClick={deviceDetailsCapability === 0 ? null : () => {
                            handleClose();
                            history.push(`/device-details/${data.id}`);
                        }}
                        disabled={deviceDetailsCapability === 0 ? true : false}>
                        <AlertTriangle className="oct_icon" />
                        <span>Device Details</span>
                    </MenuItem>

                    <MenuItem
                        className="oct_menu-item-v2"
                        onClick={applyBaselineCapability === 0 ? null : () => {
                            handleClose();
                            onApplyBaseline();
                        }}
                        disabled={applyBaselineCapability === 0 ? true : false}>
                        <Settings className="oct_icon" />
                        <span>Apply Baseline</span>
                    </MenuItem>

                    <MenuItem
                        className="oct_menu-item-v2"
                        // onClick={() => alert('Report')}>
                        onClick={baselineReportCapability === 0 ? null : () => {
                            handleClose();
                            history.push(`/baseline/${data.id}`);
                        }}
                        disabled={baselineReportCapability === 0 ? true : false}>
                        <BarChart3 className="oct_icon" />
                        <span>Baseline Report</span>
                    </MenuItem>

                    <MenuItem
                        className="oct_menu-item-v2"
                        onClick={authorizationsCapability === 0 ? null : () => {
                            handleClose();
                            history.push(`/device-authorizations/${data.id}`);
                        }}
                        disabled={authorizationsCapability === 0 ? true : false}>
                        <ShieldCheck className="oct_icon" />
                        <span>Authorizations</span>
                    </MenuItem>

                </Menu>

            </td>
        </tr>
    );

}

function mapStateToProps(state) {
    debug("DevicesTableRow mapStateToProps", state);
    const devicesPage = state.devicesPage;
    const auth = state.auth;
    return {
        devices: devicesPage.devices || [],
        userCapability: auth.userCapability,

    };
}

export default connect(mapStateToProps)(DevicesTableRow);
